import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";

export const getVisitas = createAsyncThunk("visitas/getVisita", async (id) => {
  const { data } = await axios.get(`${apiUrl}/api/v1/visitas/patient/${id}`);

  return data;
});

export const getVisitasByCitaId = createAsyncThunk(
  "visitas/getVisitaByCitaId",
  async (idCita) => {
    const { data } = await axios.get(`${apiUrl}/api/v1/visitas/${idCita}`);
    return data;
  }
);

export const updateVisitasById = createAsyncThunk(
  "visitas/updateVisitasById",
  async (body) => {
    try {
      // Create a copy of the body to avoid modifying the original
      const bodyToSend = { ...body };

      // Handle cuerpo specifically - ensure it's a string
      /*  if (bodyToSend.cuerpo && typeof bodyToSend.cuerpo === "object") {
        bodyToSend.cuerpo = JSON.stringify(bodyToSend.cuerpo);
      } */

      const fd = new FormData();

      // Handle files if any
      if (bodyToSend.files) {
        for (let i in bodyToSend.files) {
          fd.append(`file_${i}`, bodyToSend.files[i], bodyToSend.files[i].name);
        }
      }

      // Add all other fields to FormData
      for (const key in bodyToSend) {
        const value = bodyToSend[key];
        if (value !== undefined && value !== null && key !== "files") {
          fd.append(key, value);
        }
      }

      const response = await axios.post(
        `${apiUrl}/api/v1/visitas/${bodyToSend.id}`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al actualizar la visita:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  }
);

export const createVisita = createAsyncThunk(
  "visitas/createVisita",
  async (body) => {
    const fd = new FormData();
    if (body.files) {
      for (let i in body.files) {
        fd.append(`file_${i}`, body.files[i], body.files[i].name);
      }
    }
    for (const key in body) {
      const value = body[key];
      if (value !== undefined && value !== null) {
        fd.append(key, value);
      }
    }
    const { data } = await axios.post(`${apiUrl}/api/v1/visitas`, fd);
    return data;
  }
);

export const getDiagnostics = createAsyncThunk(
  "visitas/getDiagnosticsVisita",
  async (id) => {
    try {
      const { data } = await axios.get(
        `${apiUrl}/api/v1/visitas/diagbody/${id}`
      );
      return data;
    } catch (error) {
      console.error(
        "Error al eliminar la visita:",
        error.response?.data || error.message
      );
      throw error.response?.data || error;
    }
  }
);

const initialState = {
  status: "idle",
  visitas: null,
  visita: null,
  diagnostics: null,
  error: null,
};

export const visitaSlice = createSlice({
  name: "visita",
  initialState,
  reducers: {
    resetVisita(state) {
      state.visita = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getVisitasByCitaId.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getVisitasByCitaId.fulfilled, (state, action) => {
        state.status = "succeed";
        state.visita = action.payload;
      })
      .addCase(getVisitasByCitaId.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(getVisitas.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getVisitas.fulfilled, (state, action) => {
        state.status = "succeed";
        state.visitas = action.payload;
      })
      .addCase(getVisitas.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(createVisita.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(createVisita.fulfilled, (state, action) => {
        state.status = "succeed";
        state.visita = action.payload;
      })
      .addCase(createVisita.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateVisitasById.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateVisitasById.fulfilled, (state, action) => {
        state.status = "succeed";
        state.visita = action.payload;
      })
      .addCase(updateVisitasById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(getDiagnostics.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getDiagnostics.fulfilled, (state, action) => {
        state.status = "succeed";
        state.diagnostics = action.payload;
      })
      .addCase(getDiagnostics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetVisita } = visitaSlice.actions;

export default visitaSlice.reducer;

export const getAllVisitas = (state) => state.visita.visitas;
export const getVisita = (state) => state.visita.visita;
export const getDiagnosticsVisita = (state) => state.visita.diagnostics;
export const getVisitasStatus = (state) => state.visita.status;
export const getVisitasError = (state) => state.visita.error;
